import { render, staticRenderFns } from "./BoilerplateOverview.vue?vue&type=template&id=3471abe8&scoped=true&"
import script from "./BoilerplateOverview.vue?vue&type=script&lang=js&"
export * from "./BoilerplateOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3471abe8",
  null
  
)

export default component.exports